import React from 'react';
import CoverLayout from './CoverLayout';
import CtaLayout from './CtaLayout';
import QuoteLayout from './QuoteLayout';
import StatHighlightLayout from './StatHighlightLayout';
import TitleBulletsLayout from './TitleBulletsLayout';
import ComparisonLayout from './ComparisonLayout';
import TwoColumnsLayout from './TwoColumnsLayout';
import EditorialComparisonLayout from './editorial/EditorialComparisonLayout';
import EditorialCoverLayout from './editorial/EditorialCoverLayout';
import EditorialCtaLayout from './editorial/EditorialCtaLayout';
import EditorialQuoteLayout from './editorial/EditorialQuoteLayout';
import EditorialStatHighlightLayout from './editorial/EditorialStatHighlightLayout';
import EditorialTitleBulletsLayout from './editorial/EditorialTitleBulletsLayout';
import EditorialTwoColumnsLayout from './editorial/EditorialTwoColumnsLayout';
import SpotlightComparisonLayout from './spotlight/SpotlightComparisonLayout';
import SpotlightCoverLayout from './spotlight/SpotlightCoverLayout';
import SpotlightCtaLayout from './spotlight/SpotlightCtaLayout';
import SpotlightQuoteLayout from './spotlight/SpotlightQuoteLayout';
import SpotlightStatHighlightLayout from './spotlight/SpotlightStatHighlightLayout';
import SpotlightTitleBulletsLayout from './spotlight/SpotlightTitleBulletsLayout';
import SpotlightTwoColumnsLayout from './spotlight/SpotlightTwoColumnsLayout';

const classicLayouts: Record<string, React.ComponentType<any>> = {
  cover: CoverLayout,
  'title-bullets': TitleBulletsLayout,
  quote: QuoteLayout,
  'stat-highlight': StatHighlightLayout,
  cta: CtaLayout,
  comparison: ComparisonLayout,
  'two-columns': TwoColumnsLayout
};

const templateLayouts: Record<string, Record<string, React.ComponentType<any>>> = {
  classic: classicLayouts,
  editorial: {
    cover: EditorialCoverLayout,
    'title-bullets': EditorialTitleBulletsLayout,
    quote: EditorialQuoteLayout,
    'stat-highlight': EditorialStatHighlightLayout,
    cta: EditorialCtaLayout,
    comparison: EditorialComparisonLayout,
    'two-columns': EditorialTwoColumnsLayout
  },
  spotlight: {
    cover: SpotlightCoverLayout,
    'title-bullets': SpotlightTitleBulletsLayout,
    quote: SpotlightQuoteLayout,
    'stat-highlight': SpotlightStatHighlightLayout,
    cta: SpotlightCtaLayout,
    comparison: SpotlightComparisonLayout,
    'two-columns': SpotlightTwoColumnsLayout
  }
};

export const getStudioLayout = (layoutType: string, template = 'classic') => {
  const selectedTemplate = templateLayouts[template] || classicLayouts;
  return selectedTemplate[layoutType] || classicLayouts[layoutType] || TitleBulletsLayout;
};
